import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type DeleteProductAttributeMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DeleteCoreProductAttributeInput;
}>;

export type DeleteProductAttributeMutationResult = { __typename?: 'Mutation' } & {
  deleteCoreProductAttribute: { __typename?: 'DeleteCoreProductAttributePayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const DeleteProductAttributeDocument = /*#__PURE__*/ gql`
  mutation deleteProductAttribute($input: DeleteCoreProductAttributeInput!) {
    deleteCoreProductAttribute(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useDeleteProductAttributeMutation__
 *
 * To run a mutation, you first call `useDeleteProductAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductAttributeMutation, { data, loading, error }] = useDeleteProductAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductAttributeMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteProductAttributeMutationResult, DeleteProductAttributeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<DeleteProductAttributeMutationResult, DeleteProductAttributeMutationVariables>(
    DeleteProductAttributeDocument,
    options
  );
}
export type DeleteProductAttributeMutationHookResult = ReturnType<typeof useDeleteProductAttributeMutation>;
